import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SortTopicsService {

  constructor(
    private _http: HttpClient
  ) { }

  getAllTopics(organizationId) {
    return this._http.get(environment.url + "/getAllTopics/" + organizationId);
  }

  createTopic(topic) {
    return this._http.post(environment.url + "/createTopic/", topic);
  }

  updateTopic(topic) {
    return this._http.put(environment.url + "/topic/", topic);
  }

  deleteTopic(topic) {
    return this._http.put(environment.url + "/topic/delete", topic);
  }
  
}
